import { Portal } from '@material-ui/core'
import { ComponentVersionsInherit, ComponentVersions_3_0, Skeleton, styled } from 'opensolar-ui'
import { ProductLoadingTile } from 'pages/ordering/catalogv3/ProductLoadingTile'

const Container = styled('div')({
  width: '100%',
  boxSizing: 'border-box',
})

const SearchBarContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  height: '66px',
  background: 'white',
  justifyContent: 'center',
  alignItems: 'center',

  // taken from ShopSubheader3
  boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%)',
  borderTop: `1px solid ${theme.palette.grey[200]}`,
}))

const PageContainer = styled('div')({
  display: 'flex',
  width: '100%',
  padding: '0 24px',
  gap: '24px',
  flexDirection: 'column',
  background: '#F6F9FC',
  boxSizing: 'border-box',
})

const SectionContainer = styled('div')({
  display: 'flex',
  width: '100%',
  gap: '6px',
  flexDirection: 'column',
})

const ConnectBarContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  height: '167px',
  background: 'white',
  flexDirection: 'column',
  gap: '10px',
  justifyContent: 'center',
  padding: '0 20px',
  boxSizing: 'border-box',
}))

const ProductContainer = styled('div')({
  display: 'flex',
  overflow: 'hidden',
  width: 'fit-content',
  gap: '24px',
})

export const ShopLoadingPage = () => {
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Container>
        <Portal container={() => document.getElementById('main-header')}>
          <SearchBarContainer>
            <Skeleton width={692} height={40} />
          </SearchBarContainer>
        </Portal>
        <PageContainer>
          <ConnectBarContainer>
            <Skeleton width={700} height={60} />
            <Skeleton width={200} height={40} />
          </ConnectBarContainer>
          <ShopLoadingSection />
          <ShopLoadingSection />
          <ShopLoadingSection />
          <ShopLoadingSection />
          <Skeleton width="100%" height={453} />
        </PageContainer>
      </Container>
    </ComponentVersionsInherit>
  )
}

const ShopLoadingSection = () => {
  return (
    <SectionContainer>
      <Skeleton width={171} height={24} />
      <ProductContainer>
        <ProductLoadingTile />
        <ProductLoadingTile />
        <ProductLoadingTile />
        <ProductLoadingTile />
        <ProductLoadingTile />
      </ProductContainer>
    </SectionContainer>
  )
}
